import React, { useId } from "react";
import { Form, Switch } from "antd";
import { Localize } from "components/service";

const DocumentActiveField = ({ form }) => {
  const controlId = useId();
  const active = Form.useWatch("active", form);
  const labelKey = active === false ? "APP_SETTINGS.Label_Inactive" : "APP_SETTINGS.Label_Active";
  const activeLabel = Localize({ children: labelKey }).props.children;

  return (
    <Form.Item
      name="active"
      className="app-settings-document-active"
      label={<Localize>{labelKey}</Localize>}
      htmlFor={controlId}
      valuePropName="checked"
      getValueProps={(value) => ({ checked: value === true })}
      extra={active === null ? <Localize>APP_SETTINGS.Active_NotSet</Localize> : undefined}
    >
      <Switch id={controlId} aria-label={activeLabel} />
    </Form.Item>
  );
};

export default DocumentActiveField;
